<ng-multiselect-dropdown name="mediaType" style="display: block; background-color: white; color:black"
  class="omargin-left" [placeholder]="'select'" [settings]="dropdownSettings" [data]="items"
  (onSelectAll)="selectAllStaticItems($event)" (onDeSelectAll)="selectAllDeStaticItems($event)"
  [(ngModel)]="selectedItem" (onSelect)="onSelect($event)" (onDeSelect)="onDeSelect($event)">
</ng-multiselect-dropdown>